<template>
  <!-- 学校名称 -->
  <a-form-item label="学校">
    <a-select
      showSearch
      class="form-cell"
      placeholder="请选择来自的学校"
      :filterOption="false"
      @search="searchSchool"
      :notFoundContent="searchSchoolLoading ? undefined : '没有查询结果'"
      v-model="modelSchool"
    >
      <a-spin v-if="searchSchoolLoading" slot="notFoundContent" size="small" />
      <a-select-option v-for="d in schoolList" :key="d.id">{{
        d.schoolName
      }}</a-select-option>
    </a-select>
  </a-form-item>
</template>
<script>
import school from '../../api/school'
import Vue from 'vue'

export default {
  name: 'CSchoolSelect',
  props: ['schoolCode'],
  data() {
    return {
      searchSchoolLoading: false, //搜索学校loading
      schoolList: [], //学校list
      modelSchool: this.schoolCode,
      accRole: '',
    }
  },
  watch: {
    modelSchool() {
      Vue.ls.set('schoolId', this.modelSchool)
      this.$emit('update:schoolCode', this.modelSchool)
    },
    schoolCode() {
      this.modelSchool = this.schoolCode
      Vue.ls.set('schoolId', this.modelSchool)
    },
  },
  methods: {
    //搜索学校
    searchSchool(val = '') {
      this.searchSchoolLoading = true
      school.searchSchool({ schoolName: val }).then((res) => {
        this.searchSchoolLoading = false
        this.schoolList = res.data
        // 用户刚点进班级页面显示后端返回数组中第一个学校
        if (!this.modelSchool && this.accRole != 4) {
          this.modelSchool = res.data[0].id
        }
        if (!this.modelSchool && this.accRole == 4 && location.hash.indexOf('classList') != -1) {
          this.modelSchool = res.data[0].id
        }
      })
    },
  },
  created() {
    this.searchSchool()
    this.$store.dispatch('getUserInfo').then((res) => {
      this.accRole = res.accRole.id
    })
  },
}
</script>
